import { Icon, IconProps } from '@chakra-ui/react'

export const AssessmentIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" boxSize={6} fill="currentColor" {...props}>
    <path d="M15.95 35.5h16.1v-3h-16.1Zm0-8.5h16.1v-3h-16.1ZM11 44q-1.2 0-2.1-.9Q8 42.2 8 41V7q0-1.2.9-2.1Q9.8 4 11 4h18.05L40 14.95V41q0 1.2-.9 2.1-.9.9-2.1.9Zm16.55-27.7V7H11v34h26V16.3ZM11 7v9.3V7v34V7Z" />
  </Icon>
)
